export default "__VITE_ASSET__CVmCGIol__"